import React from "react";
import { useMiniChat } from "../../context/MiniChatContext";
import MiniChat from "./MiniChat";

const SIDEBAR_WIDTH = 220; // matches --chat-sidebar-width
const CHAT_WIDTH = 320;
const GAP = 8;
const BASE_RIGHT = 16; // matches ChatSidebar right: 16px

/**
 * Renders a floating MiniChat window for each open chat,
 * positioned from right to left alongside the Chat sidebar.
 */
export default function ChatPopupManager() {
  const { openChats } = useMiniChat();

  if (openChats.length === 0) return null;

  return (
    <>
      {openChats.map((chat, index) => {
        const rightPos =
          BASE_RIGHT + SIDEBAR_WIDTH + GAP + index * (CHAT_WIDTH + GAP);
        return (
          <MiniChat key={chat.id} chat={chat} rightPosition={rightPos} />
        );
      })}
    </>
  );
}
